import React, { useRef } from "react"
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ZoomLens } from "../ZoomLens";
import { ArrowLeft, ArrowRight } from "../Arrow";

import "./layout-slider.css"

const LayoutSlider = ({ data }) => {
    const sliderRef = useRef(null)
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    };

    return (
        <div className='relative variant--slider'>
            <div className='variant--slider__container'>
                <Slider {...settings} ref={sliderRef}>
                    {data.gallery.map((item, index) => (
                        <div key={index} className='carousel-slide'>
                            <div className='relative image'>
                                <ZoomLens imgUrl={item.gatsbyImageData.images.fallback.src} />
                            </div>
                        </div>
                    ))}
                </Slider>
                <div className="next" onClick={() => sliderRef.current.slickNext()}>
                    <ArrowRight/>
                </div>
                <div className="prev" onClick={() => sliderRef.current.slickPrev()}>
                    <ArrowLeft/>
                </div>
            </div>
        </div>
    )
}

export default LayoutSlider